<template>
    <div id="prequalification">
        <my-header></my-header>
        <div class="banner">
            <!--<img src="../../../assets/images/invitemanage/banner01.png"/>-->
            <img src="../../../assets/images/invitemanage/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>资格预审</span></h2>
                    <p>{{ inquiringBidTime ? '资格预审截止时间：'+inquiringBidTime : '' }}</p>
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <section class="small-container">
                <h2>
                    <img src="../../../assets/images/invitemanage/title_pre.png"/>
                    <!--<el-button type="primary"><i class="downloadIcon"></i>下载全部</el-button>-->
                </h2>
                <div class="launchattachmentList">
                    <div class="launch-title">资格预审文件模板：</div>
                    <div class="launch-file">
                        <div class="file-name" v-for="file in launchattachmentList" @click="fileHandleDownload(file)" title="点击下载" style="text-decoration: underline;cursor: pointer;"><i class="el-icon-document"></i>{{file.attachName}}</div>
                    </div>
                </div>
                <el-table
                    :data="preQualificationReplyVOList"
                    :cell-style="$root.tableCellStyle"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100">
                    </el-table-column>
                    <el-table-column
                        prop="qualificationCriteria"
                        label="资审指标项">
                    </el-table-column>
                    <el-table-column
                        width="250"
                        prop="enterCondition"
                        :show-overflow-tooltip="true"
                        label="入围条件">
                    </el-table-column>
                    <el-table-column
                        width="230"
                        prop="replyRequest"
                        :show-overflow-tooltip="true"
                        label="回复要求">
                    </el-table-column>
                    <el-table-column
                        width="250"
                        :show-overflow-tooltip="true"
                        label="供应商回复">
                        <template slot-scope="scope">
                            <span v-if="$route.params.entrance == 2">{{ scope.row.qualificationNetworkReply }}</span>
                            <el-input v-else v-model="scope.row.qualificationNetworkReply" type="textarea" ></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <el-form label-width="450px" class="fileForm" v-if="isShowFile">
                    <el-form-item label="资审申请附件">
                        <page-upload :files="applyAttachmentList"
                                     class="fileUpload"
                                     :editFlag="true"
                                     :disable="$route.params.entrance == 2"
                                     :notMany="$route.params.entrance == 2"
                                     attachmentType="89"
                                     :limitType="2"
                                     :isIconTable="3">
                        </page-upload>
                    </el-form-item>
                    <el-form-item label="拟派团队附件">
                        <page-upload :files="teamAttachmentList"
                                     class="fileUpload"
                                     :editFlag="true"
                                     :disable="$route.params.entrance == 2"
                                     :notMany="$route.params.entrance == 2"
                                     attachmentType="90"
                                     :limitType="2"
                                     :isIconTable="3">
                        </page-upload>
                    </el-form-item>
                </el-form>
                <div style="margin-top: 20px;" v-if="$route.params.entrance == 1" >
                    <el-button class="cancelBtn" style="padding: 10px 40px;font-size: 14px;background: #cfcfcf;" @click="cancel">取消</el-button>
                    <el-button type="primary" style="padding: 10px 40px;font-size: 14px;"  @click="submit" >提交</el-button>
                </div>
            </section>
        </div>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../MasterHeader.vue';
    export default {
        name: 'prequalification',
        data() {
            return {
                launchattachmentList:[],
                editFlag:false,
                projectName: '',//项目名称
                preQualificationReplyVOList: [],//
                inquiringBidTime: '',//截止时间
                isTime: true,//是否过了截止时间 true 未过期
                applyAttachmentList: [],//资审申请附件
                teamAttachmentList: [],//拟派团队附件
                isShowFile: false,//是否显示附件
                cancelId: '',//跳转的id
            }
        },
        components: {MyHeader},
        created(){
            this.$root.activeIndex = 'win';
            this.getData();//初始化数据
        },
        methods: {
            getData(){//获取数据
                let that = this;
                this.$root.getHttp('/v1/outerformflow/getQulificationPreCheckDetail/'+this.$route.params.formId,function (res) {
                    that.preQualificationReplyVOList = res.data.data.qulifiPreCheckReplyVOList;
                    that.applyAttachmentList = res.data.data.applyAttachmentList;
                    that.teamAttachmentList = res.data.data.teamAttachmentList;
                    that.isShowFile = true;
                    that.inquiringBidTime = res.data.data.preQualificationResponsedea || '';
                    that.cancelId = res.data.data.dealBisVo.flowFormExtMng.id;
//                    that.isTime = res.data.data.isTime;
                    that.projectName =  res.data.data.dealBisVo.flowFormExtMng.formTitle;
                    that.launchattachmentList = res.data.data.launchattachmentList;
                })
            },
            cancel(){//取消，跳转到
                this.$router.push('/master/processManagement/'+this.cancelId+'/1');
            },
           submit(row){
               let that = this;
               let objJson ={
                   flowFormId: this.$route.params.formId,//招标流程id
                   preQualificationReplyVOList: that.preQualificationReplyVOList,
                   applyAttachmentList: that.applyAttachmentList,
                   teamAttachmentList: that.teamAttachmentList
               };
               that.$root.postHttp('/v1/outerformflow/replyPreQulification',objJson,function (res) {
                   that.$message.success('提交成功');
                   setTimeout( () => {
                       that.$router.push('/master/processManagement/'+that.cancelId+'/1');
                   },1000)
               });
           },
            fileHandleDownload(file){
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.$root.downloadFile({
                                attachName: file.attachName,
                                attachPath: file.attachPath
                            })
                        }
                    }
                });
            },
            fileListHandleDownload(val,type) {
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then( () => {
                    if(type == 1){
                        that.$root.downloadFile({
                            attachName: val.answerAttachName,
                            attachPath: val.answerAttachUrl || val.askAttachUrl
                        });
                    }else {
                        that.$root.postHttp('/v1/outerformflow/bidFile/down',{
                            formId: val.flowFormId,
                            relatedId: val.id,
                            type: val.askAttachType
                        },function (res) {
                            //code 1 成功了再进行下载
                            that.$root.downloadFile({
                                attachName: val.askAttachName,
                                attachPath: val.askAttachUrl
                            });
                            that.getData();
                        });
                    }

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消下载'
                    })
                });
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#prequalification {
    padding: 80px 0 50px;
    min-height: 85vh;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .launchattachmentList{
        font-size: 15px;
        text-align: left;
    }
    .launchattachmentList{
        font-size: 15px;
        text-align: left;
        .launch-title {
            float: left;
            width: 150px;
        }
        .launch-file {
            width: 800px;
            float: left;
        }
        .file-name{
            padding-bottom: 10px;
            text-direction: underline;
        }
    }
    .banner {
        img {
            width: 100%;
            min-width:1300px;
            height: 140px;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding-bottom: 60px;
        /*background: #fff;*/
    }
    .el-tabs {
        background: #fff;
        /*padding-top: 20px;*/
        & .el-tabs__header {
            margin: 0 0 10px;
        }
        & .el-tabs__nav {
            margin-left: 40px;
        }
        & .el-tabs__item {
            font-size: 14px;
            height: 50px;
        }
        & .el-tabs__item.is-active {
            color: $--text-color;
            font-weight: 700;
        }
        & .el-tabs__active-bar {
            bottom: -2px;
            height: 12px;
            background: url('../../../assets/images/register/at.png') no-repeat center 0;
        }
        & .el-tabs__nav-wrap::after {
            height: 1px;
            background-color: $--secondary-fill-color;
        }
    }
    .small-container {
        width: 1200px;
        box-sizing: border-box;
        margin: 0px auto;
        padding: 30px 50px 30px;
        background: #fff;
        h2 {
            margin-bottom: 20px;
            overflow: hidden;
            img {
                float: left;
                width: 282px;
                height: 30px;
            }
            .el-button {
                float: right;
                padding: 5px 25px;
                height: 30px;
                i {
                    display: inline-block;
                    margin-right: 8px;
                    width: 20px;
                    height: 20px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/invitemanage/icon04.png') no-repeat;
                    background-position: 0 center;
                }
            }
        }
       /* .el-table{
            margin-top: 20px;
            th {
              text-align: center;
            }
            .cell {
                text-align: center;
            }
        }*/
        & .tips {
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            color: $--primary-color;
            background: url('../../../assets/images/register/icon03.png') no-repeat left center;
        }
        .fileForm {
            .el-form-item {
                margin: 0;
                padding: 10px 0;
                border-bottom: 1px solid $--primary-fill-color;
            }
        }
        .fileUpload{
            overflow: hidden;
            .el-upload,
            .file-list{
                float: left;
            }
            .file-list {
                margin-left: 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/Prequalification.vue